import { API_BASE } from './config';

// Fire-and-forget activity tracking for Admin Console -> Portal Usage.
// Never await this, never let it throw into a caller — a tracking failure
// must be completely invisible to the user.
//
// To add tracking to any new or existing page: import `{ track }` here and
// call `track(user?.username, ACTION_TYPE, 'Human Readable Page Name',
// optionalDetailsObject)` right after that action's own success path —
// never before, never awaited, never wrapped around the real logic.
// Page-view tracking is automatic (see components/ActivityTracker.jsx) and
// needs no per-page code; only non-navigation actions need this call:
//   - 'DOWNLOAD' / 'EXPORT' — after a file download/Excel export completes
//   - 'UPLOAD'              — after a file upload succeeds
//   - 'EDIT'                — after a create/update save succeeds
//   - 'FILTER_APPLIED'      — from an explicit "Apply filters" action, not
//                             on every keystroke/state change (same reason
//                             PAGE_VIEW is debounced server-side)
export function track(username, actionType, pageName, details) {
    if (!username) return;
    try {
        fetch(`${API_BASE}/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, action_type: actionType, page_name: pageName, details: details || null }),
            keepalive: true, // lets the request survive a route change / tab close mid-flight
        }).catch(() => { /* swallow — see file header */ });
    } catch (e) { /* swallow — see file header */ }
}
